(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["global-search-suggestions"]) return;
  try {
    

/*
  Search Suggestions
*/
const SearchSugg = () => {
  const DEBUG = false;
  const ELEMS = {
    searchInput: {},
    sugg: document.querySelector(".search-suggestions"),
    megaMenu: document.querySelector(".desktop-nav-dropdown"),
    headerRoot: document.querySelector(".header-root"),
  };
  const TIMERS = {
    stopSearchForInput: undefined,
    canShow: undefined,
    show: undefined,
    hide: undefined,
  };
  const INTERVALS = {
    findSearchInput: undefined,
    deactivateSugg: undefined,
  };

  function Init() {
    ELEMS.searchInput.desktop = document.querySelector(".sk-desktop .search-bar [type='text']");
    ELEMS.searchInput.mobile = document.querySelector(".sk-mobile .search-bar [type='text']");
    ELEMS.searchInput.desktop.addEventListener("focus", ShowDesktop);
    ELEMS.searchInput.desktop.addEventListener("input", ShowDesktop);
    ELEMS.searchInput.mobile.addEventListener("focus", ShowMobile);
    ELEMS.searchInput.mobile.addEventListener("input", ShowMobile);

    INTERVALS.findSearchInput = setInterval(() => {
      // Check every second for search inputs again since app removes it occasionally for the first 10 seconds
      ELEMS.searchInput.desktop = document.querySelector(".sk-desktop .search-bar [type='text']");
      ELEMS.searchInput.mobile = document.querySelector(".sk-mobile .search-bar [type='text']");
      ELEMS.searchInput.desktop.addEventListener("focus", ShowDesktop);
      ELEMS.searchInput.desktop.addEventListener("input", ShowDesktop);
      ELEMS.searchInput.mobile.addEventListener("focus", ShowMobile);
      ELEMS.searchInput.mobile.addEventListener("input", ShowMobile);
    }, 1000);

    TIMERS.stopSearchForInput = setTimeout(() => {
      if (INTERVALS.findSearchInput) clearInterval(INTERVALS.findSearchInput);
    }, 10000);

    document.body.addEventListener("click", Hide);
  }

  // Show
  // - view = "all" | "desktop" | "mobile"
  function Show(view = "all", e = undefined) {
    Helpers.ClearAllTimers();

    TIMERS.canShow = setTimeout(() => {
      if ((e && e.type === "input" && e.inputType === "insertText") || Helpers.IsMegaMenuActive()) {
        Hide(undefined, false);
        return;
      }

      // Hide if input on desktop is greater than 0
      if (Helpers.IsSearchPopupActive() && ELEMS.searchInput.desktop.value.length > 0 && view !== "mobile") {
        Hide(undefined, false);
        return;
      }

      // Hide if input on mobile is greater than 0
      if (Helpers.IsSearchPopupActive() && ELEMS.searchInput.mobile.value.length > 0 && view !== "desktop") {
        Hide(undefined, false);
        return;
      }

      if (DEBUG) console.log("show");

      ELEMS.sugg.classList.add("enabled");

      TIMERS.show = setTimeout(() => {
        // Show search suggestions
        ELEMS.sugg.classList.add("active");
        ELEMS.headerRoot.classList.add("header-root--search-sugg");

        // Check if search suggestions should be hidden if anything else is opened
        if (INTERVALS.deactivateSugg) clearInterval(INTERVALS.deactivateSugg);

        INTERVALS.deactivateSugg = setInterval(() => {
          if (Helpers.IsMegaMenuActive()) {
            Hide(undefined, false);
            return;
          }

          // Hide if input on desktop is greater than 0
          if (Helpers.IsSearchPopupActive() && ELEMS.searchInput.desktop.value.length > 0 && view !== "mobile") {
            Hide(undefined, false);
            return;
          }

          // Hide if input on mobile is greater than 0
          if (Helpers.IsSearchPopupActive() && ELEMS.searchInput.mobile.value.length > 0 && view !== "desktop") {
            Hide(undefined, false);
            return;
          }
        }, 500);
      }, 100);
    }, 50);
  }

  // Wrapper for desktop
  function ShowDesktop(e = undefined) {
    Show("desktop", e);
  }

  // Wrapper for mobile
  function ShowMobile(e = undefined) {
    Show("mobile", e);
  }

  // Hide
  // - Set clickEvent to false if not from a click event
  function Hide(e = undefined, clickEvent = true) {
    // Check if clicking on search suggestion or other element
    if (clickEvent) {
      if (!e) return;
      if (Helpers.IsSearchSuggElem(e.target)) return;
    }

    // Prepare to hide
    Helpers.ClearAllTimers();
    if (INTERVALS.deactivateSugg) clearInterval(INTERVALS.deactivateSugg);

    if (DEBUG) console.log("hide");

    // Hide
    ELEMS.sugg.classList.remove("active");
    ELEMS.headerRoot.classList.remove("header-root--search-sugg");

    TIMERS.hide = setTimeout(() => {
      ELEMS.sugg.classList.remove("enabled");
    }, 320);
  }

  // ===== Helpers =====
  const Helpers = (() => {
    function IsSearchPopupActive() {
      if (document.querySelector(".usf-popup") === null) return false;
      if (document.querySelector(".usf-popup").classList.contains("usf-hide")) return false;
      return true;
    }

    function IsMegaMenuActive() {
      if (ELEMS.megaMenu.classList.contains("active")) return true;
      return false;
    }

    function IsSearchSuggElem(target = undefined) {
      if (target === undefined) return false;
      if (target.classList.contains("search-suggestions")) return true;
      if (target.parentElement.classList.contains("search-suggestions")) return true;
      if (target.parentElement.parentElement.classList.contains("search-suggestions")) return true;
      if (target.parentElement.parentElement.parentElement.classList.contains("search-suggestions")) return true;
      return false;
    }

    function ClearAllTimers() {
      if (TIMERS.show) clearTimeout(TIMERS.show);
      if (TIMERS.hide) clearTimeout(TIMERS.hide);
    }

    return Object.freeze({
      IsSearchPopupActive,
      IsMegaMenuActive,
      IsSearchSuggElem,
      ClearAllTimers,
    });
  })();

  // Start
  Init();

  return Object.freeze({
    Show,
    Hide,
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {SearchSugg();})
} else {
  SearchSugg();
}


  } catch(e) { console.error(e); }
})();
})();
